<!-- Notifications toggle -->
<!-- <button mat-icon-button (click)="openPanel()" #notificationsOrigin>
    <ng-container *ngIf="_notificationsService.unreadCount > 0">
        <span class="absolute right-0 flex items-center justify-center" style="top:12px; left:15px">
            <span style="color: #E03137;
                background: #E03137 !important;
                height: 8px !important;
                width: 8px !important;
                border-radius: 12px !important;
                border: 2px;">
            </span>
        </span>
    </ng-container>
    <mat-icon style="height: 32px; width: 32px;" [svgIcon]="'heroicons_outline:mail'"></mat-icon>
</button> -->

<!-- Notifications toggle -->
<button mat-icon-button (click)="openPanel()" #notificationsOrigin class="relative">
    <ng-container *ngIf="_notificationsService.unreadCount > 0">
        <span class="absolute top-0 right-0 flex items-center justify-center text-white text-[10px] font-bold" style="
        background-color: #E03137;
        height: 18px;
        min-width: 18px;
        padding: 0 4px;
        border-radius: 9999px;
        line-height: 18px;
      ">
            {{ unreadCountDisplay }}
        </span>
    </ng-container>
    <mat-icon style="height: 32px; width: 32px;" [svgIcon]="'heroicons_outline:mail'"></mat-icon>
</button>


<!-- Notifications panel -->
<ng-template #notificationsPanel>
    <div
        class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

        <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary justify-between">
            <div class="sm:hidden -ml-1 mr-3">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:x'"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">{{'NOTIFICATION.TITLE.NOTIFICATIONS' | transloco }}</div>
            <div class="flex">
                <button mat-icon-button (click)="refresh()" [matTooltip]="'CONTROL.REFRESH' | transloco">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_outline:refresh'"></mat-icon>
                </button>
                <button mat-icon-button (click)="movetoPageNotifications()"
                    [matTooltip]="'NOTIFICATION.VIEW_ALL_NOTIFICATIONS' | transloco">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:view-list'"></mat-icon>
                </button>
                <button mat-icon-button [matTooltip]="'NOTIFICATION.MARK_ALL_AS_READ' | transloco"
                    [disabled]="_notificationsService.unreadCount === 0" (click)="markAllAsRead()">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:mail-open'"></mat-icon>
                </button>
            </div>
        </div>

        <div class="relative flex flex-col flex-auto sm:max-h-90 divide-y overflow-y-auto bg-card overflow-x-hidden">
            <ng-container *ngFor="let notification of _notificationsService.notifications; trackBy: trackByFn">
                <div class="content-notification flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5 max-h-20"
                    [ngClass]="{'unread': notification.unread}">

                    <ng-container *ngIf="notification.link">
                        <ng-container *ngIf="!notification.useRouter">
                            <a class="flex flex-auto py-5 pl-6 cursor-pointer" [href]="notification.link">
                                <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                            </a>
                        </ng-container>
                        <ng-container *ngIf="notification.useRouter">
                            <a class="flex flex-auto py-5 pl-6 cursor-pointer" [routerLink]="notification.link">
                                <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                            </a>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="!notification.link">
                        <div class="flex flex-auto py-3 pl-5">
                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                        </div>
                    </ng-container>
                    <div class="relative flex flex-col m-2 self-center">
                        <!-- Indicator -->
                        <button class="w-6 h-6 min-h-6" mat-icon-button (click)="toggleRead(notification)"
                            [matTooltip]="notification.unread ? 'Mark as read' : 'Mark as unread'">
                            <mat-icon *ngIf="notification.unread" class="min-w-2.5 min-h-2.5 text-current dot-unread"
                                [color]="primary" [svgIcon]="'mat_solid:circle'">
                            </mat-icon>
                            <mat-icon *ngIf="!notification.unread" class="min-w-2.5 min-h-2.5 text-current dot-read"
                                [color]="primary" [svgIcon]="'mat_solid:circle'">
                            </mat-icon>
                        </button>
                        <!-- Remove -->

                    </div>
                </div>

                <!-- Notification content template -->
                <ng-template #notificationContent>
                    <!-- Title, description & time -->
                    <div class="flex flex-col flex-auto">
                        <div class="flex justify-between items-center cursor-pointer"
                            (click)="openDialogNotificationDetail(notification)">
                            <ng-container *ngIf="notification.msgTitle">
                                <div class="w-3/5 line-clamp-1" [ngClass]="{'font-bold': notification.unread}">
                                    {{notification.msgTitle}}
                                </div>
                            </ng-container>
                            <div class="text-sm text-secondary">
                                {{notification.createDate | dateTimeFormatPipe }}
                                <!-- {{notification.createdTime | date:'MMM dd, h:mm a'}} -->
                            </div>
                        </div>

                        <ng-container *ngIf="notification.msgSummary">
                            <div (click)="openDialogNotificationDetail(notification)"
                                class="line-clamp-1 cursor-pointer" [ngClass]="{'font-bold': notification.unread}"
                                [innerHTML]="notification.msgSummary | keepHtmlExtend"></div>
                        </ng-container>
                        <!-- <ng-container *ngIf="notification.description">
                            <div class="line-clamp-1" [innerHTML]="notification.description"></div>
                        </ng-container> -->
                    </div>
                </ng-template>
            </ng-container>
            <!-- No notifications -->
            <ng-container *ngIf="!_notificationsService.notifications || !_notificationsService.notifications.length">
                <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100">
                        <mat-icon class="text-primary-500-700" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">{{'NOTIFICATION.NO_NOTIFICATION' | transloco
                        }}</div>
                    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">
                        {{'NOTIFICATION.WHEN_YOU_HAVE_NOTIFICATIONS_THEY_WILL_APPEAR_HERE' | transloco }}</div>
                </div>
            </ng-container>

        </div>
    </div>
</ng-template>